/*
	Author : Sohan Kumar Dash
    Project : Pearlgreen
    Date : 16-04-2019
*/

//@module Favorites
define(
	'Favorites.Router'
,	[
		'Favorites.View'
	,	'ProductList.Model'
	,	'Profile.Model'
	,	'Session'

	,	'Backbone'
	,	'underscore'
	]
,	function (
		FavoritesView
	,	ProductListModel
	,	ProfileModel
	,	Session

	,	Backbone
	,	_
	)
{
	'use strict';

	// @lass Favorites.Router @extends Backbone.Router
	return Backbone.Router.extend({

		routes: {
			//'Favorites': 'showWishlistLists'
			'Favorites': 'showWishlistDetails'
		,	'Favorites/': 'showWishlistDetails'
		,	'Favorites/:id': 'showWishlistDetails'
		}

	,	initialize: function (application)
		{
			this.application = application;
			this.Profile = ProfileModel.getInstance();
		}
	/*,	showWishlistLists: function()  //Shows All WishLists
		{
			var self = this;
			if(this.Profile.get('isLoggedIn') !== "T")
			{
				var login = Session.get('touchpoints.login');
				login += '&origin_hash=' + encodeURIComponent(Backbone.history.fragment);
				window.location.href = login;
			}
			else
			{
				this.application.ProductListModule.Utils.getProductListsPromise().done(function (model)
				{
					var view = new FavoritesView({
						application: self.application
					,	collection: model
					,	isWishListDetail: false
					});
					view.showContent();
				});
			}
		}*/
		// @method favoritesPage dispatch the 'go to home page' route
	,	showWishlistDetails: function (id,options)		//Shows All Items within particular WishLists
		{			
			var self = this
			,	Profile = ProfileModel.getInstance()
			,	utils = this.application.ProductListModule.Utils;
			if(Profile.get('isLoggedIn') != "F" && Profile.get('isGuest') != "T")
			{
				if(id != '' && id != null)
				{
					utils.getProductList(id).done(function(model){

						var view = new FavoritesView({
							application: self.application
						,	model: new ProductListModel(model)
						,	isWishListDetail: true
						});
						view.showContent();
					});
				}
				else
				{
					utils.getProductListsPromise().done(function(collection){
						
						var model = collection.find(function(plist){
							return plist.get('name') == "Favorites" ;
						})
						,	template_id = model ? (model.get('internalid') ? model.get('internalid') : 'tmpl_'+model.get('templateId')) : ''
						,	url = Backbone.history.fragment;
						
						url += url.lastIndexOf('/') !== -1 ? template_id : "/"+ template_id;

						Backbone.history.navigate( url ,{trigger:false})

						utils.getProductList(template_id).done(function(model){
							var view = new FavoritesView({
								application: self.application
							,	model: new ProductListModel(model)
							,	isWishListDetail: true
							});
							view.showContent();
						});
					});
				}
				
			}
			else
			{
				var login = Session.get('touchpoints.login');
				login += '&origin_hash=' + encodeURIComponent(Backbone.history.fragment);
				window.location.href = login;
			}
		}
	});
});
